export default __webpack_public_path__ + "static/media/Screenshot (1080).9b3847a1.png";